var map = {
	"./FAQ.md": 522,
	"./GettingStarted.md": 523
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 524;



//////////////////
// WEBPACK FOOTER
// ./src/data/pages nonrecursive ./~/text-loader!\.md$
// module id = 524
// module chunks = 0